import React from 'react';
import { Redirect } from 'react-router-dom';

import AuthStorage from '../storage/AuthStorage';
import { verifySubdomainBase, verifyUser } from './ConfigSubdomain';

export default function PrivateRoute({ component: Component, ...rest }) {

  const authStorage = new AuthStorage(window.location.pathname);
  const dataSubDomain = authStorage.getConfigSubdomain();
  const userDetails = authStorage.GetCurrentUser();

  console.log("privateroute.j333s ");
  let folderAPP = process.env.NEXT_PUBLIC_FOLDER_APP + "/";

  verifySubdomainBase();
  verifyUser();

  if (userDetails.userName === "")
    redirect(folderAPP);

  return (
    <>

      {userDetails.userName === "" ? (
        <></>
      ) :
        (
          <Component />
        )
      }

    </>

  );

  /*
  return (

    <Route {...userDetails} >
      {userDetails.userName === "" ? (
        
      ) :
        (
          <Component />
        )
      }
    </Route>

  );

  */

}
